import { useLocation, useParams } from 'react-router-dom';

import AnimalsOverview from '../../features/animals/layouts/overview';
import AnimalDetail from '../../features/animals/layouts/detail';
import AnimalStats from '../../features/animals/layouts/stats';
import CreateAnimalForm from '../../features/animals/forms/create';
import EditAnimalForm from '../../features/animals/forms/edit';
import CowLiquidation from '../../features/billing/layouts/cow-liquidation';

// TSS vite/01 §"Pages are thin".
export default function AnimalsPage() {
    const { id } = useParams();
    const { pathname } = useLocation();

    if (pathname.endsWith('/new')) return <CreateAnimalForm />;
    if (id && pathname.endsWith('/edit')) return <EditAnimalForm animalId={id} />;
    if (id && pathname.endsWith('/stats')) return <AnimalStats animalId={id} />;
    if (id && pathname.endsWith('/liquidation')) return <CowLiquidation animalId={id} />;
    if (id) return <AnimalDetail animalId={id} />;
    return <AnimalsOverview sex="female" />;
}
